import React, { useState } from 'react';
import { Link as RLink } from "react-router-dom";

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import AddIcon from '@mui/icons-material/Add';

import Dialog, { DialogProps } from '@mui/material/Dialog';

export function ToolBar() {
	const sx = {
		backgroundColor: '#eeeeee',
		display: 'flex',
		height: 45,
		width: '100%',
		paddingLeft: 6,
		paddingRight: 10,
		alignItems: 'center',
	};
	const sxleft = {
		flexGrow: 1,
		//backgroundColor: 'green',
	};
	const sxright = {
		flexGrow: 4,
		//backgroundColor: 'yellow',
	};
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState<DialogProps['scroll']>('paper');

  const handleClickOpen = (scrollType: DialogProps['scroll']) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
	  console.log('is this closing happening?');
    setOpen(false);
  };

  const descriptionElementRef = React.useRef<HTMLElement>(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

	return (
		<Box position="fixed" sx={sx}>
			<Box sx={sxleft}>
                {/*<Typography>Tickets</Typography>*/}
			</Box>
			<Link component={RLink} to={"/ticket/byContext/1"}>Home</Link> - 
			<Link component={RLink} to={"/ticket/byContext/2"}>Office</Link> - 
			<Link component={RLink} to={"/ticket/byContext/3"}>Outside</Link> - 
			<Link component={RLink} to={"/ticket/byContext/4"}>Computer</Link> - 
			<Link component={RLink} to={"/ticket/byContext/5"}>Hermine</Link> - 
			<Link component={RLink} to={"/ticket/byContext/6"}>Contacts</Link> - 
			<Link component={RLink} to={"/ticket/byContext/8"}>Offcom</Link> - 
			<Link component={RLink} to={"/ticket/byContext/9"}>Everywhere</Link> - 
			<Box sx={sxright}>
                {/* 202509020801
				<Button
					variant="outlined"
					startIcon={<AddIcon />}
					size="small"
					onClick={handleClickOpen('paper')}
				>
					Add Ticket
				</Button>
                */}
			</Box>
		</Box>
	)
}
